import React from 'react';
import styled from 'styled-components';

const PolicyContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 70vh;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto 60px;
`;

const Section = styled.div`
  margin-bottom: 50px;
  background: #f8f9fa;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: #333;
  margin-bottom: 25px;
  font-size: 1.8rem;
  font-weight: 600;
`;

const SectionContent = styled.div`
  color: #555;
  line-height: 1.8;
  font-size: 1.1rem;
  
  p {
    margin-bottom: 15px;
  }
  
  ul, ol {
    margin: 15px 0;
    padding-left: 30px;
    
    li {
      margin-bottom: 10px;
    }
  }
  
  strong {
    color: #333;
    font-weight: 600;
  }
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const ContactTitle = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ContactItem = styled.div`
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactLabel = styled.span`
  color: #555;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const CookiePolicy = () => {
  return (
    <PolicyContainer>
      <Title>Политика использования файлов cookie</Title>
      <Subtitle>
        Настоящая Политика использования файлов cookie определяет порядок использования файлов cookie на сайте foodstar.pro
      </Subtitle>

      <Section>
        <SectionTitle>1. Что такое файлы cookie</SectionTitle>
        <SectionContent>
          <p>
            Файлы cookie (куки) — это небольшие текстовые файлы, которые сохраняются на вашем устройстве (компьютере, планшете или мобильном телефоне) при посещении веб-сайта. Файлы cookie позволяют сайту запоминать ваши действия и предпочтения на определенный период времени, чтобы вам не нужно было повторно вводить эту информацию при возвращении на сайт или переходе с одной страницы на другую.
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>2. Какие файлы cookie мы используем</SectionTitle>
        <SectionContent>
          <p>
            На нашем сайте мы используем следующие типы файлов cookie:
          </p>
          <ul>
            <li>
              <strong>Необходимые cookie</strong> — эти файлы cookie необходимы для работы сайта и не могут быть отключены в наших системах. Обычно они устанавливаются только в ответ на ваши действия, такие как настройка параметров конфиденциальности, вход в систему или заполнение форм.
            </li>
            <li>
              <strong>Функциональные cookie</strong> — эти файлы cookie позволяют сайту предоставлять расширенную функциональность и персонализацию. Они могут устанавливаться нами или сторонними поставщиками услуг, чьи сервисы мы добавили на наши страницы.
            </li>
            <li>
              <strong>Аналитические cookie</strong> — эти файлы cookie позволяют нам подсчитывать посещения и источники трафика, чтобы мы могли измерять и улучшать производительность нашего сайта. Они помогают нам узнать, какие страницы наиболее и наименее популярны, и увидеть, как посетители перемещаются по сайту.
            </li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>3. Использование сервисов аналитики</SectionTitle>
        <SectionContent>
          <p>
            На нашем сайте мы используем следующие сервисы аналитики для сбора информации о посещениях и поведении пользователей:
          </p>
          
          <p>
            <strong>3.1. Яндекс.Метрика</strong>
          </p>
          <p>
            Мы используем Яндекс.Метрику — веб-аналитический сервис компании Яндекс, который помогает нам анализировать использование сайта. Яндекс.Метрика собирает информацию о том, как вы используете наш сайт, включая:
          </p>
          <ul>
            <li>Страницы, которые вы посещаете</li>
            <li>Время, проведенное на каждой странице</li>
            <li>Источник перехода на сайт</li>
            <li>Информацию об устройстве и браузере</li>
            <li>IP-адрес (в обезличенном виде)</li>
          </ul>
          <p>
            Эта информация используется для улучшения работы сайта и понимания потребностей пользователей. Яндекс.Метрика использует файлы cookie для сбора этой информации. Подробнее о политике конфиденциальности Яндекс.Метрики можно узнать на странице: <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">https://yandex.ru/legal/confidential/</a>
          </p>

          <p>
            <strong>3.2. Пиксель ВКонтакте</strong>
          </p>
          <p>
            Мы используем пиксель ВКонтакте (VK Pixel) — инструмент для отслеживания конверсий и ретаргетинга. Пиксель ВКонтакте помогает нам:
          </p>
          <ul>
            <li>Отслеживать действия пользователей на сайте</li>
            <li>Показывать релевантную рекламу пользователям, которые посещали наш сайт</li>
            <li>Измерять эффективность рекламных кампаний</li>
          </ul>
          <p>
            Пиксель ВКонтакте использует файлы cookie для идентификации пользователей. Подробнее о политике конфиденциальности ВКонтакте можно узнать на странице: <a href="https://vk.com/privacy" target="_blank" rel="noopener noreferrer">https://vk.com/privacy</a>
          </p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>4. Управление файлами cookie</SectionTitle>
        <SectionContent>
          <p>
            Вы можете управлять файлами cookie через настройки вашего браузера. Большинство браузеров позволяют:
          </p>
          <ul>
            <li>Просматривать файлы cookie, которые хранятся на вашем устройстве</li>
            <li>Удалять все или отдельные файлы cookie</li>
            <li>Блокировать файлы cookie от определенных сайтов</li>
            <li>Блокировать все файлы cookie</li>
            <li>Удалять все файлы cookie при закрытии браузера</li>
          </ul>
          <p>
            Обратите внимание, что если вы отключите файлы cookie, некоторые функции сайта могут работать некорректно или быть недоступны.
          </p>
          <p>
            Инструкции по управлению файлами cookie в популярных браузерах:
          </p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/ru/kb/kuki-informaciya-kotoruyu-sajty-sohranyayut-na-vashem" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.microsoft.com/ru-ru/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noopener noreferrer">Internet Explorer</a></li>
            <li><a href="https://support.apple.com/ru-ru/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a href="https://help.opera.com/ru/latest/web-preferences/#cookies" target="_blank" rel="noopener noreferrer">Opera</a></li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>5. Ваши права</SectionTitle>
        <SectionContent>
          <p>
            Вы имеете право:
          </p>
          <ul>
            <li>Получать информацию о том, какие файлы cookie используются на нашем сайте</li>
            <li>Отказаться от использования файлов cookie (кроме необходимых для работы сайта)</li>
            <li>Удалить файлы cookie через настройки браузера</li>
            <li>Обратиться к нам с вопросами относительно использования файлов cookie</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>6. Изменения в политике</SectionTitle>
        <SectionContent>
          <p>
            Мы можем периодически обновлять настоящую Политику использования файлов cookie. При внесении существенных изменений мы уведомим вас, разместив новую версию политики на этой странице с указанием даты последнего обновления.
          </p>
          <p>
            Дата последнего обновления: {new Date().toLocaleDateString('ru-RU', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </SectionContent>
      </Section>

      <ContactInfo>
        <ContactTitle>Контактная информация</ContactTitle>
        <ContactItem>
          <ContactLabel>Адрес:</ContactLabel>
          <ContactValue>446301, Самарская область, г. Отрадный, Спортивная ул., д. 7</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ИНН:</ContactLabel>
          <ContactValue>6318073403</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>КПП:</ContactLabel>
          <ContactValue>637201001</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ОГРН:</ContactLabel>
          <ContactValue>1246300002409</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Email:</ContactLabel>
          <ContactValue>lagomlife@mail.ru</ContactValue>
        </ContactItem>
      </ContactInfo>
    </PolicyContainer>
  );
};

export default CookiePolicy;
